import { initAnimationObserver } from '../_shared/animationObserver';

const blocks = document.querySelectorAll('.portal-grid');

blocks.forEach(block => {
    if (block.dataset.animationEnabled) {
        const grid = block.querySelector('.portal-grid__tiles');
        const innerBlocks = Array.from(grid.children);
        const staggerDelay = parseInt(block.dataset.staggerDelay) || 150;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    innerBlocks.forEach((el, i) => {
                        el.style.setProperty('--animate-delay', `${i * staggerDelay}ms`);
                        el.classList.add('animate__animated', 'animate__fadeIn');
                    });
                    observer.unobserve(entry.target);
                }
            });
        }, { rootMargin: '-100px', threshold: 0.1 });

        observer.observe(grid);
    }
});